/* SEO for every page in 3 languages: title (<title>), h1 (visible), desc (meta description + hero lead).
   Page keys must match src/pages/home/pages.json. */

const SEO = {
    ru: {
        home: {
            title: "GPS-мониторинг транспорта и видеонаблюдение в Нукусе | ALL SYSTEMS",
            h1: "GPS-мониторинг транспорта и видеонаблюдение",
            desc: "Установка GPS-трекеров Teltonika, контроль расхода топлива на Wialon и монтаж камер Hikvision, Dahua, HOWEN. Нукус, Каракалпакстан и Хорезм.",
        },
        gps: {
            title: "GPS-мониторинг транспорта | ALL SYSTEMS",
            h1: "GPS-мониторинг транспорта",
            desc: "Отслеживание транспорта в реальном времени: маршруты, пробег, стоянки, скорость и топливо. Установка GPS-трекеров и настройка Wialon под ключ.",
        },
        gps_nukus: {
            title: "Установка GPS-трекера в Нукусе | ALL SYSTEMS",
            h1: "Установка GPS-трекеров в Нукусе",
            desc: "Монтаж GPS-трекеров Teltonika FMB920 и FMB125 в Нукусе с выездом мастера. Подключение к Wialon, датчики топлива, гарантия и обслуживание.",
        },
        gps_khorezm: {
            title: "GPS-мониторинг транспорта в Хорезме | ALL SYSTEMS",
            h1: "GPS-мониторинг транспорта в Хорезме",
            desc: "GPS-контроль транспорта по всей Хорезмской области: установка трекеров и датчиков топлива, настройка Wialon с выездом на место.",
        },
        gps_urgench: {
            title: "Установка GPS в Ургенче | ALL SYSTEMS",
            h1: "Установка GPS-трекеров в Ургенче",
            desc: "Монтаж GPS-оборудования в Ургенче: трекеры Teltonika, датчики уровня топлива, подключение к Wialon и обучение диспетчеров.",
        },
        fuel: {
            title: "Контроль расхода топлива | ALL SYSTEMS",
            h1: "Контроль расхода топлива",
            desc: "Учёт заправок и сливов, выявление перерасхода и фактические нормы расхода. Датчики уровня топлива Эскорт TD 150 и TD BLE с GPS-мониторингом.",
        },
        sensor: {
            title: "Датчики уровня топлива Эскорт TD 150 и TD BLE | ALL SYSTEMS",
            h1: "Датчики уровня топлива",
            desc: "Продажа и установка датчиков уровня топлива Эскорт TD 150 и беспроводного TD BLE. Тарировка бака и подключение к GPS-трекеру.",
        },
        wialon: {
            title: "Wialon Local — система GPS-мониторинга | ALL SYSTEMS",
            h1: "GPS-мониторинг на платформе Wialon Local",
            desc: "Wialon Local — платформа №1 для мониторинга транспорта: карта онлайн, отчёты, уведомления и мобильное приложение. Подключение и настройка.",
        },
        teltonika: {
            title: "GPS-трекеры Teltonika | ALL SYSTEMS",
            h1: "GPS-трекеры Teltonika",
            desc: "Продажа и установка GPS-трекеров Teltonika FMB920 и FMB125 с гарантией. Подбор трекера под ваш транспорт и подключение к Wialon.",
        },
        fmb920: {
            title: "Teltonika FMB920 — купить и установить | ALL SYSTEMS",
            h1: "GPS-трекер Teltonika FMB920",
            desc: "Компактный GPS-трекер Teltonika FMB920 для легковых авто и спецтехники. Продажа, скрытый монтаж и подключение к Wialon в Нукусе.",
        },
        fmb125: {
            title: "Teltonika FMB125 — трекер с датчиками топлива | ALL SYSTEMS",
            h1: "GPS-трекер Teltonika FMB125",
            desc: "Teltonika FMB125 — GPS-трекер с подключением до 5 датчиков уровня топлива и RS-485. Установка на грузовики, автобусы и спецтехнику.",
        },
        escort: {
            title: "Датчик топлива Эскорт TD 150 | ALL SYSTEMS",
            h1: "Датчик уровня топлива Эскорт TD 150",
            desc: "Эскорт TD 150 — точный датчик уровня топлива для контроля сливов и заправок. Установка, тарировка и подключение к GPS-трекеру.",
        },
        video: {
            title: "Видеонаблюдение Hikvision и Dahua | ALL SYSTEMS",
            h1: "Видеонаблюдение под ключ",
            desc: "Проектирование и монтаж видеонаблюдения на камерах Hikvision, Dahua и HOWEN — для офисов, складов, магазинов и транспорта.",
        },
        camera_install: {
            title: "Установка камер видеонаблюдения в Нукусе | ALL SYSTEMS",
            h1: "Установка камер видеонаблюдения в Нукусе",
            desc: "Монтаж IP-камер для домов, офисов и складов в Нукусе: подбор оборудования, прокладка кабеля, настройка удалённого просмотра с телефона.",
        },
        hikvision: {
            title: "Камеры Hikvision — продажа и установка | ALL SYSTEMS",
            h1: "Камеры Hikvision",
            desc: "IP-камеры Hikvision: купольные, уличные и поворотные PTZ. Продажа, монтаж и настройка видеонаблюдения с гарантией.",
        },
        dahua: {
            title: "Камеры Dahua — продажа и установка | ALL SYSTEMS",
            h1: "Камеры Dahua",
            desc: "Установка камер Dahua: уличные IP67, купольные и камеры с ИИ-детекцией людей и транспорта. Настройка просмотра с телефона.",
        },
        faceid: {
            title: "Терминалы Face ID Hikvision | ALL SYSTEMS",
            h1: "Терминалы Face ID",
            desc: "Терминалы распознавания лиц Hikvision для учёта рабочего времени и контроля доступа. Установка и настройка под ваш объект.",
        },
        turnstile: {
            title: "Турникеты и контроль доступа | ALL SYSTEMS",
            h1: "Турникеты и контроль доступа",
            desc: "Установка турникетов с Face ID, картами и пропусками. Системы контроля и учёта доступа для предприятий и офисов.",
        },
        warehouse: {
            title: "Видеонаблюдение для склада | ALL SYSTEMS",
            h1: "Видеонаблюдение для склада",
            desc: "Камеры для складов и территорий: уличные IP-камеры с ИК-подсветкой, контроль погрузки и периметра, запись в архив.",
        },
        office: {
            title: "Видеонаблюдение для офиса | ALL SYSTEMS",
            h1: "Видеонаблюдение для офиса",
            desc: "Купольные IP-камеры для офисов и магазинов: контроль сотрудников и посетителей, удалённый просмотр с телефона.",
        },
        truck: {
            title: "Камеры и видеорегистраторы HOWEN на грузовики | ALL SYSTEMS",
            h1: "Камеры на грузовой транспорт",
            desc: "Видеорегистраторы и AHD-камеры HOWEN для грузовиков и автобусов: салон, дорога, обзор вокруг машины, работа в паре с GPS.",
        },
        fleet: {
            title: "GPS-мониторинг автопарка | ALL SYSTEMS",
            h1: "GPS-мониторинг автопарка",
            desc: "Контроль автопарка предприятия: где техника, сколько топлива, пробег, простои и работа водителей — в одном кабинете Wialon.",
        },
        logistics: {
            title: "GPS для логистических компаний | ALL SYSTEMS",
            h1: "GPS-мониторинг для логистики",
            desc: "Контроль маршрутов, времени доставки и стоянок грузового транспорта. Геозоны, уведомления и отчёты для логистических компаний.",
        },
        contacts: {
            title: "Контакты ALL SYSTEMS — Нукус",
            h1: "Контакты ALL SYSTEMS",
            desc: "Телефон +998 93 099 60 60, e-mail allsystems.uz@gmail.com, офис в Нукусе. Оставьте заявку на GPS-мониторинг или видеонаблюдение.",
        },
        about: {
            title: "О компании ALL SYSTEMS",
            h1: "О компании ALL SYSTEMS",
            desc: "ALL SYSTEMS — GPS-мониторинг транспорта и видеонаблюдение в Нукусе. Работаем по Каракалпакстану и Хорезму на платформе Wialon.",
        },
    },

    uz: {
        home: {
            title: "Nukusda transport GPS-monitoringi va videokuzatuv | ALL SYSTEMS",
            h1: "Transport GPS-monitoringi va videokuzatuv",
            desc: "Teltonika GPS-trekerlarini o‘rnatish, Wialon orqali yoqilg‘i sarfini nazorat qilish, Hikvision, Dahua va HOWEN kameralarini montaj qilish. Nukus, Qoraqalpog‘iston va Xorazm.",
        },
        gps: {
            title: "Transport GPS-monitoringi | ALL SYSTEMS",
            h1: "Transport GPS-monitoringi",
            desc: "Transportni real vaqtda kuzatish: marshrutlar, yurilgan masofa, to‘xtash joylari, tezlik va yoqilg‘i. GPS-treker o‘rnatish va Wialon’ni to‘liq sozlash.",
        },
        gps_nukus: {
            title: "Nukusda GPS-treker o‘rnatish | ALL SYSTEMS",
            h1: "Nukusda GPS-trekerlarni o‘rnatish",
            desc: "Nukusda Teltonika FMB920 va FMB125 GPS-trekerlarini usta chiqishi bilan o‘rnatish. Wialon’ga ulash, yoqilg‘i datchiklari, kafolat va xizmat ko‘rsatish.",
        },
        gps_khorezm: {
            title: "Xorazmda transport GPS-monitoringi | ALL SYSTEMS",
            h1: "Xorazmda transport GPS-monitoringi",
            desc: "Butun Xorazm viloyati bo‘ylab transportni GPS orqali nazorat qilish: trekerlar va yoqilg‘i datchiklarini o‘rnatish, Wialon’ni joyida sozlash.",
        },
        gps_urgench: {
            title: "Urganchda GPS o‘rnatish | ALL SYSTEMS",
            h1: "Urganchda GPS-trekerlarni o‘rnatish",
            desc: "Urganchda GPS-uskunalarni montaj qilish: Teltonika trekerlari, yoqilg‘i darajasi datchiklari, Wialon’ga ulash va dispetcherlarni o‘qitish.",
        },
        fuel: {
            title: "Yoqilg‘i sarfini nazorat qilish | ALL SYSTEMS",
            h1: "Yoqilg‘i sarfini nazorat qilish",
            desc: "Quyish va to‘kishlarni hisobga olish, ortiqcha sarfni aniqlash va haqiqiy sarf me’yorlari. GPS-monitoring bilan Eskort TD 150 va TD BLE yoqilg‘i datchiklari.",
        },
        sensor: {
            title: "Eskort TD 150 va TD BLE yoqilg‘i datchiklari | ALL SYSTEMS",
            h1: "Yoqilg‘i darajasi datchiklari",
            desc: "Eskort TD 150 va simsiz TD BLE yoqilg‘i darajasi datchiklarini sotish va o‘rnatish. Bakni tarirovka qilish va GPS-trekerga ulash.",
        },
        wialon: {
            title: "Wialon Local — GPS-monitoring tizimi | ALL SYSTEMS",
            h1: "Wialon Local platformasida GPS-monitoring",
            desc: "Wialon Local — transport monitoringi uchun №1 platforma: onlayn xarita, hisobotlar, bildirishnomalar va mobil ilova. Ulash va sozlash.",
        },
        teltonika: {
            title: "Teltonika GPS-trekerlari | ALL SYSTEMS",
            h1: "Teltonika GPS-trekerlari",
            desc: "Teltonika FMB920 va FMB125 GPS-trekerlarini kafolat bilan sotish va o‘rnatish. Transportingizga mos treker tanlash va Wialon’ga ulash.",
        },
        fmb920: {
            title: "Teltonika FMB920 — sotib olish va o‘rnatish | ALL SYSTEMS",
            h1: "Teltonika FMB920 GPS-trekeri",
            desc: "Yengil avtomobillar va maxsus texnika uchun ixcham Teltonika FMB920 GPS-trekeri. Nukusda sotish, yashirin montaj va Wialon’ga ulash.",
        },
        fmb125: {
            title: "Teltonika FMB125 — yoqilg‘i datchikli treker | ALL SYSTEMS",
            h1: "Teltonika FMB125 GPS-trekeri",
            desc: "Teltonika FMB125 — 5 tagacha yoqilg‘i darajasi datchigi va RS-485 ulanadigan GPS-treker. Yuk mashinalari, avtobuslar va maxsus texnikaga o‘rnatish.",
        },
        escort: {
            title: "Eskort TD 150 yoqilg‘i datchigi | ALL SYSTEMS",
            h1: "Eskort TD 150 yoqilg‘i darajasi datchigi",
            desc: "Eskort TD 150 — to‘kish va quyishlarni nazorat qilish uchun aniq yoqilg‘i darajasi datchigi. O‘rnatish, tarirovka va GPS-trekerga ulash.",
        },
        video: {
            title: "Hikvision va Dahua videokuzatuv | ALL SYSTEMS",
            h1: "Videokuzatuv tizimini to‘liq o‘rnatish",
            desc: "Hikvision, Dahua va HOWEN kameralarida videokuzatuvni loyihalash va montaj qilish — ofislar, omborlar, do‘konlar va transport uchun.",
        },
        camera_install: {
            title: "Nukusda videokuzatuv kameralarini o‘rnatish | ALL SYSTEMS",
            h1: "Nukusda videokuzatuv kameralarini o‘rnatish",
            desc: "Nukusda uylar, ofislar va omborlar uchun IP-kameralarni montaj qilish: uskuna tanlash, kabel tortish, telefondan masofadan ko‘rishni sozlash.",
        },
        hikvision: {
            title: "Hikvision kameralari — sotish va o‘rnatish | ALL SYSTEMS",
            h1: "Hikvision kameralari",
            desc: "Hikvision IP-kameralari: gumbazsimon, tashqi va aylanuvchi PTZ. Kafolat bilan sotish, montaj va videokuzatuvni sozlash.",
        },
        dahua: {
            title: "Dahua kameralari — sotish va o‘rnatish | ALL SYSTEMS",
            h1: "Dahua kameralari",
            desc: "Dahua kameralarini o‘rnatish: IP67 tashqi, gumbazsimon va odam hamda transportni sun’iy intellekt bilan aniqlovchi kameralar. Telefondan ko‘rishni sozlash.",
        },
        faceid: {
            title: "Hikvision Face ID terminallari | ALL SYSTEMS",
            h1: "Face ID terminallari",
            desc: "Ish vaqtini hisobga olish va kirishni nazorat qilish uchun Hikvision yuzni tanish terminallari. Obyektingizga o‘rnatish va sozlash.",
        },
        turnstile: {
            title: "Turniketlar va kirish nazorati | ALL SYSTEMS",
            h1: "Turniketlar va kirish nazorati",
            desc: "Face ID, karta va ruxsatnomali turniketlarni o‘rnatish. Korxona va ofislar uchun kirishni nazorat qilish va hisobga olish tizimlari.",
        },
        warehouse: {
            title: "Ombor uchun videokuzatuv | ALL SYSTEMS",
            h1: "Ombor uchun videokuzatuv",
            desc: "Omborlar va hududlar uchun kameralar: IK-yoritishli tashqi IP-kameralar, yuklash va perimetr nazorati, arxivga yozish.",
        },
        office: {
            title: "Ofis uchun videokuzatuv | ALL SYSTEMS",
            h1: "Ofis uchun videokuzatuv",
            desc: "Ofis va do‘konlar uchun gumbazsimon IP-kameralar: xodimlar va tashrifchilarni nazorat qilish, telefondan masofadan ko‘rish.",
        },
        truck: {
            title: "Yuk mashinalari uchun HOWEN kameralari | ALL SYSTEMS",
            h1: "Yuk transporti uchun kameralar",
            desc: "Yuk mashinalari va avtobuslar uchun HOWEN videoregistratorlari va AHD-kameralari: salon, yo‘l, mashina atrofi, GPS bilan birga ishlaydi.",
        },
        fleet: {
            title: "Avtopark GPS-monitoringi | ALL SYSTEMS",
            h1: "Avtopark GPS-monitoringi",
            desc: "Korxona avtoparkini nazorat qilish: texnika qayerda, qancha yoqilg‘i, yurilgan masofa, bekor turish va haydovchilar ishi — bitta Wialon kabinetida.",
        },
        logistics: {
            title: "Logistika kompaniyalari uchun GPS | ALL SYSTEMS",
            h1: "Logistika uchun GPS-monitoring",
            desc: "Yuk transportining marshrutlari, yetkazib berish vaqti va to‘xtashlarini nazorat qilish. Logistika kompaniyalari uchun geozonalar, bildirishnomalar va hisobotlar.",
        },
        contacts: {
            title: "ALL SYSTEMS aloqa ma’lumotlari — Nukus",
            h1: "ALL SYSTEMS bilan bog‘lanish",
            desc: "Telefon +998 93 099 60 60, e-mail allsystems.uz@gmail.com, ofis Nukusda. GPS-monitoring yoki videokuzatuv uchun ariza qoldiring.",
        },
        about: {
            title: "ALL SYSTEMS kompaniyasi haqida",
            h1: "ALL SYSTEMS kompaniyasi haqida",
            desc: "ALL SYSTEMS — Nukusda transport GPS-monitoringi va videokuzatuv. Wialon platformasida Qoraqalpog‘iston va Xorazm bo‘ylab ishlaymiz.",
        },
    },

    en: {
        home: {
            title: "GPS Vehicle Tracking & Video Surveillance in Nukus | ALL SYSTEMS",
            h1: "GPS vehicle tracking and video surveillance",
            desc: "Teltonika GPS tracker installation, Wialon fuel monitoring and Hikvision, Dahua and HOWEN cameras. Nukus, Karakalpakstan and Khorezm, Uzbekistan.",
        },
        gps: {
            title: "GPS Vehicle Tracking | ALL SYSTEMS",
            h1: "GPS vehicle tracking",
            desc: "Real-time vehicle tracking: routes, mileage, stops, speed and fuel. Turnkey GPS tracker installation and Wialon setup.",
        },
        gps_nukus: {
            title: "GPS Tracker Installation in Nukus | ALL SYSTEMS",
            h1: "GPS tracker installation in Nukus",
            desc: "On-site installation of Teltonika FMB920 and FMB125 GPS trackers in Nukus. Wialon connection, fuel sensors, warranty and service.",
        },
        gps_khorezm: {
            title: "GPS Vehicle Tracking in Khorezm | ALL SYSTEMS",
            h1: "GPS vehicle tracking in Khorezm",
            desc: "GPS fleet tracking across the Khorezm region: on-site installation of trackers and fuel sensors and Wialon setup.",
        },
        gps_urgench: {
            title: "GPS Installation in Urgench | ALL SYSTEMS",
            h1: "GPS tracker installation in Urgench",
            desc: "GPS equipment installation in Urgench: Teltonika trackers, fuel level sensors, Wialon connection and dispatcher training.",
        },
        fuel: {
            title: "Fuel Consumption Monitoring | ALL SYSTEMS",
            h1: "Fuel consumption monitoring",
            desc: "Track refuels and fuel drains, detect overconsumption and see real consumption rates. Escort TD 150 and TD BLE fuel sensors with GPS tracking.",
        },
        sensor: {
            title: "Escort TD 150 & TD BLE Fuel Level Sensors | ALL SYSTEMS",
            h1: "Fuel level sensors",
            desc: "Sale and installation of Escort TD 150 and wireless TD BLE fuel level sensors. Tank calibration and connection to your GPS tracker.",
        },
        wialon: {
            title: "Wialon Local GPS Tracking Platform | ALL SYSTEMS",
            h1: "GPS tracking on Wialon Local",
            desc: "Wialon Local is the No. 1 vehicle tracking platform: live map, reports, alerts and a mobile app. Connection and setup by ALL SYSTEMS.",
        },
        teltonika: {
            title: "Teltonika GPS Trackers | ALL SYSTEMS",
            h1: "Teltonika GPS trackers",
            desc: "Teltonika FMB920 and FMB125 GPS trackers with warranty and installation. We pick the right tracker for your vehicles and connect it to Wialon.",
        },
        fmb920: {
            title: "Teltonika FMB920 — Buy & Install | ALL SYSTEMS",
            h1: "Teltonika FMB920 GPS tracker",
            desc: "Compact Teltonika FMB920 GPS tracker for cars and special vehicles. Sale, hidden installation and Wialon connection in Nukus.",
        },
        fmb125: {
            title: "Teltonika FMB125 Tracker with Fuel Sensors | ALL SYSTEMS",
            h1: "Teltonika FMB125 GPS tracker",
            desc: "Teltonika FMB125 supports up to 5 fuel level sensors and RS-485. Installation on trucks, buses and special vehicles.",
        },
        escort: {
            title: "Escort TD 150 Fuel Sensor | ALL SYSTEMS",
            h1: "Escort TD 150 fuel level sensor",
            desc: "Escort TD 150 is an accurate fuel level sensor for detecting drains and refuels. Installation, calibration and GPS tracker connection.",
        },
        video: {
            title: "Hikvision & Dahua Video Surveillance | ALL SYSTEMS",
            h1: "Turnkey video surveillance",
            desc: "Design and installation of video surveillance with Hikvision, Dahua and HOWEN cameras for offices, warehouses, shops and vehicles.",
        },
        camera_install: {
            title: "CCTV Camera Installation in Nukus | ALL SYSTEMS",
            h1: "CCTV camera installation in Nukus",
            desc: "IP camera installation for homes, offices and warehouses in Nukus: equipment selection, cabling and remote viewing on your phone.",
        },
        hikvision: {
            title: "Hikvision Cameras — Sale & Installation | ALL SYSTEMS",
            h1: "Hikvision cameras",
            desc: "Hikvision IP cameras: dome, outdoor bullet and PTZ. Sale, installation and setup with warranty.",
        },
        dahua: {
            title: "Dahua Cameras — Sale & Installation | ALL SYSTEMS",
            h1: "Dahua cameras",
            desc: "Dahua camera installation: IP67 outdoor, dome and AI cameras that detect people and vehicles. Remote viewing on your phone.",
        },
        faceid: {
            title: "Hikvision Face ID Terminals | ALL SYSTEMS",
            h1: "Face ID terminals",
            desc: "Hikvision face recognition terminals for time tracking and access control. Installation and setup for your site.",
        },
        turnstile: {
            title: "Turnstiles & Access Control | ALL SYSTEMS",
            h1: "Turnstiles and access control",
            desc: "Turnstile installation with Face ID, cards and passes. Access control and attendance systems for businesses and offices.",
        },
        warehouse: {
            title: "Warehouse Video Surveillance | ALL SYSTEMS",
            h1: "Warehouse video surveillance",
            desc: "Cameras for warehouses and yards: outdoor IP cameras with IR night vision, loading and perimeter monitoring, recording to archive.",
        },
        office: {
            title: "Office Video Surveillance | ALL SYSTEMS",
            h1: "Office video surveillance",
            desc: "Dome IP cameras for offices and shops: monitor staff and visitors and watch remotely from your phone.",
        },
        truck: {
            title: "HOWEN Truck Cameras & Dashcams | ALL SYSTEMS",
            h1: "Cameras for trucks and buses",
            desc: "HOWEN dashcams and AHD cameras for trucks and buses: cabin, road and all-round view, working together with GPS tracking.",
        },
        fleet: {
            title: "Fleet GPS Tracking | ALL SYSTEMS",
            h1: "Fleet GPS tracking",
            desc: "Manage your company fleet: vehicle location, fuel, mileage, idling and driver behaviour — all in one Wialon dashboard.",
        },
        logistics: {
            title: "GPS Tracking for Logistics Companies | ALL SYSTEMS",
            h1: "GPS tracking for logistics",
            desc: "Monitor routes, delivery times and truck stops. Geofences, alerts and reports for logistics companies.",
        },
        contacts: {
            title: "Contact ALL SYSTEMS — Nukus",
            h1: "Contact ALL SYSTEMS",
            desc: "Phone +998 93 099 60 60, email allsystems.uz@gmail.com, office in Nukus. Request GPS tracking or video surveillance.",
        },
        about: {
            title: "About ALL SYSTEMS",
            h1: "About ALL SYSTEMS",
            desc: "ALL SYSTEMS provides GPS vehicle tracking and video surveillance in Nukus, serving Karakalpakstan and Khorezm on the Wialon platform.",
        },
    },
};

export default SEO;
